module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-viewer-full-d92d774c23511aa8c137826abf9374ef.png";